import React from 'react';
import { CheckCircle2, Circle, X } from 'lucide-react';

export default function TourCatalogModal({
  open,
  tourOrder = [],
  tourMeta = {},
  hasCompleted,
  busy = false,
  onClose,
  onStart,
}) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="tour-catalog-title"
    >
      <div className="w-full max-w-md overflow-hidden rounded-2xl border border-pp-line bg-pp-surface shadow-pp-lg">
        <div className="flex items-start justify-between gap-3 border-b border-pp-line px-5 py-4">
          <div>
            <h2 id="tour-catalog-title" className="text-lg font-semibold tracking-tight text-pp-ink">
              Guided tours
            </h2>
            <p className="mt-1 text-sm text-pp-muted">
              Each tour highlights buttons and panels on the real screens. Start a module below.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-1.5 text-pp-muted hover:bg-pp-paper hover:text-pp-ink"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <ul className="divide-y divide-pp-line px-2 py-2">
          {tourOrder.map((id) => {
            const meta = tourMeta[id];
            if (!meta) return null;
            const done = hasCompleted?.(id);
            return (
              <li key={id} className="flex items-start gap-3 px-3 py-3">
                <div className="mt-0.5 text-pp-accent">
                  {done ? (
                    <CheckCircle2 className="h-5 w-5" aria-label="Completed" />
                  ) : (
                    <Circle className="h-5 w-5 text-pp-muted" aria-hidden />
                  )}
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-semibold text-pp-ink">{meta.title}</p>
                  <p className="mt-0.5 text-sm text-pp-muted">{meta.description}</p>
                </div>
                <button
                  type="button"
                  onClick={() => onStart(id)}
                  className="shrink-0 rounded-xl bg-pp-accent px-3 py-1.5 text-sm font-semibold text-white hover:bg-pp-accentHover disabled:opacity-50"
                >
                  {busy ? 'Starting…' : 'Start'}
                </button>
              </li>
            );
          })}
        </ul>

        <div className="border-t border-pp-line px-5 py-3 text-xs text-pp-muted">
          After each tour you can keep going to the next module or return here anytime from Help.
        </div>
      </div>
    </div>
  );
}
